import { render, staticRenderFns } from "./InsurerPage.vue?vue&type=template&id=19efa8b0&"
import script from "./InsurerPage.vue?vue&type=script&lang=js&"
export * from "./InsurerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports